import React from 'react'
import { Pagination } from 'react-bootstrap'

interface Props {
  page: number;
  limit: number;
  total: number;
  onChange: (page: number) => void;
}

const AdminPagination = ({ page, limit, total, onChange }: Props) => {
  const totalPages = Math.ceil(total / limit)

  if (totalPages <= 1) return null

  const visiblePages = Array.from(new Set([
    1,
    page - 1,
    page,
    page + 1,
    totalPages,
  ]))
    .filter((item) => item >= 1 && item <= totalPages)
    .sort((a, b) => a - b)

  return (
    <nav className="pl4-admin-pagination" aria-label="Paginacion">
      <Pagination>
        <Pagination.Prev
          disabled={page === 1}
          onClick={() => page > 1 && onChange(page - 1)}
        />
        {visiblePages.map((item, index) => {
          const previousPage = visiblePages[index - 1]

          return (
            <React.Fragment key={item}>
              {previousPage && item - previousPage > 1 && <Pagination.Ellipsis disabled />}
              <Pagination.Item active={item === page} onClick={() => onChange(item)}>
                {item}
              </Pagination.Item>
            </React.Fragment>
          )
        })}
        <Pagination.Next
          disabled={page === totalPages}
          onClick={() => page < totalPages && onChange(page + 1)}
        />
      </Pagination>
    </nav>
  )
}

export default AdminPagination
